/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Additional_RequirementsInputs */

const de_additional_requirements = /** @type {(inputs: Additional_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliche Anforderungen`)
};

/** @type {(inputs: Additional_RequirementsInputs) => LocalizedString} */
const en_additional_requirements = () => /** @type {LocalizedString} */ ('additional_requirements')

/**

* @param {Additional_RequirementsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const additional_requirements = /** @type {((inputs?: Additional_RequirementsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_RequirementsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_additional_requirements(inputs)
	return en_additional_requirements(inputs)
});